<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="loading">
      <span class="loader"></span>
    </span>
    <div v-if="property && !loading" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
        v-model="activeTab"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96"></i>
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <property-view-global v-if="activeTab === '1'" :property="property" @propertyUpdated="get"
            @onCommentCreated="commentCreated" :key="componentKey" />
        </tab-pane>
        <tab-pane title="global" id="2">
          <span slot="title">
            <i class="ni ni-circle-08"></i>
            {{ $t("COMMON.OWNERS") }}
          </span>
          <property-contact-list-table
             v-if="activeTab === '2'"
            :property="property"
            :filterProperty="property?.id"
          />
        </tab-pane>
        <tab-pane title="global" id="3">
          <span slot="title">
            <i class="ni ni-circle-08"></i>
            {{ $t("COMMON.COMMUNICATIONS") }}
          </span>
          <property-communication-list-table
            v-if="activeTab === '3'"
            :property="property"
            :filterProperty="property?.id"
            @onCommunicationCreated="communicationCreated"
            :key="componentKey"
            :isCollection="true"
          />
        </tab-pane>
        <tab-pane
          v-if="
            $currentUserCan($permissions.PERM_VIEW_ANY_TRANSACTIONS_PROPERTIES)
          "
          title="global"
          id="4"
        >
          <span slot="title">
            <i class="fas fa-money-bill"></i>
            {{ $t("COMMON.PAYMENTS") }}
          </span>
          <payment-list-table
             v-if="activeTab === '4'"
            :refreshView="get"
            :property="property"
            :filterProperty="property?.id"
            @onTransactionAdded="transactionAdded"
            :key="componentKey"
          />
        </tab-pane>

        <!-- <tab-pane title="global" id="4">
          <span slot="title">
            <i class="ni ni-money-coins"></i>
            {{ $t("COMMON.BIDS") }}
          </span>
          <property-view-bids :property="property" />
        </tab-pane> -->

        <tab-pane
          title="files"
          id="6"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
        >
          <span slot="title">
            <i class="ni ni-folder-17"></i>
            {{ $t("COMMON.FILES") }}
          </span>
          <div class="elite-tabs-wrapper-content">
            <list-file-component  v-if="activeTab === '6'" :object="property" />
          </div>
        </tab-pane>

        <tab-pane
          title="logs"
          id="7"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file"></i>
            {{ $t("COMMON.LOGS") }}
          </span>
          <property-view-logs  v-if="activeTab === '7'" :property="property" />
        </tab-pane>
        <tab-pane title="comments" id="8">
          <span slot="title">
            <i class="fas fa-comments"></i>
            {{ $t("COMMON.COMMENTS") }}
          </span>
          <property-comments 
           v-if="activeTab === '8'"
          :object="property" 
          :canAddComment="true"
          @onCommentsChanged="commentCreated"
          :key="componentKey" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { Tabs, TabPane } from "@/components";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import PropertyViewGlobal from "../partials/PropertyViewGlobal.vue";
import PropertyViewLogs from "../partials/PropertyViewLogs.vue";
import PropertyContactListTable from "../partials/PropertyContactListTable.vue";
import PropertyCommunicationListTable from "../partials/PropertyCommunicationListTable.vue";
import PaymentListTable from "../partials/PropertyTransactionListTable.vue";
import PropertyComments from "../partials/PropertyComments.vue";

export default {
  layout: "view-property-component",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    PropertyViewGlobal,
    PropertyViewLogs,
    ListFileComponent,
    PropertyContactListTable,
    PropertyCommunicationListTable,
    PaymentListTable,
    PropertyComments,
  },

  mixins: [],

  props: {
    propertyId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      property: null,
      loading: true,
      componentKey: 0,
      activeTab: '1',
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        this.loading = true;
        await this.$store.dispatch("propertiesCollections/get", this.propertyId);
        this.property = this.$store.getters["propertiesCollections/propertiesCollection"];
        this.loading = false;
      console.log('onPropertyChange',this.property);
        this.$emit("propertyChange", this.property);
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    communicationCreated() {
      this.componentKey += 1;
    },
    commentCreated() {
      this.componentKey += 1;
    },
    transactionAdded(){
      this.get();
      this.$emit("onTransactionAdded", true);
      this.componentKey += 1;
    }
  },
};
</script>
